var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemperature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.221,
    height: 19.221,
    viewBox: "0 0 19.221 19.221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "temperature") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#26c875;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.617,0a3.6,3.6,0,1,0,3.6,3.6A3.61,3.61,0,0,0,15.617,0Zm0,4.805a1.2,1.2,0,1,1,1.2-1.2A1.2,1.2,0,0,1,15.617,4.805ZM9.61,4.2A4.2,4.2,0,1,0,1.2,4.2v6.25a5.4,5.4,0,1,0,9.61,3.36,5.357,5.357,0,0,0-1.2-3.36Zm-4.2,12.614a3,3,0,0,1-1.8-5.4V4.2a1.8,1.8,0,1,1,3.6,0V11.42a3,3,0,0,1-1.8,5.4Zm.6-4.7V4.2a.6.6,0,1,0-1.2,0v7.917a1.8,1.8,0,1,0,1.2,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperature);
export default __webpack_public_path__ + "static/media/temperature.d5dc34978c6772626e3f6ce7646b7d66.svg";
export { ForwardRef as ReactComponent };